import { gql } from '@apollo/client';

import baseFields from '../base';

const APPOINTMENT_ASSIGNMENTS = gql`
  fragment AppointmentAssignments on Assignment {
    ${baseFields}
    status
    notary {
      id
      firstName
      lastName
    }
  }
`;
export default APPOINTMENT_ASSIGNMENTS;
